import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ConfigService } from 'src/app/shared/services/config.service';
import { SnackBarService } from '../../../shared/snack-bar/services/snack-bar.service';
import { basicSnackBarConfig } from 'src/app/utils/default-configs/configuration';
@Component({
  selector: 'app-reciever-save-address',
  templateUrl: './reciever-save-address.component.html',
  styleUrls: ['./reciever-save-address.component.css'],
})
export class RecieverSaveAddressComponent implements OnInit {
  saveRecieverAddressList = ['Yes', 'No'];
  recieverAddressGroup: FormGroup;
  constructor(
    private configService: ConfigService,
    private fb: FormBuilder,
    private snackBarService: SnackBarService
  ) {}

  ngOnInit(): void {
    this.intialiseSaveAddressGroup();
    this.getddressConfig();
  }

  intialiseSaveAddressGroup() {
    this.recieverAddressGroup = this.fb.group({
      saveAddress: new FormControl('', Validators.compose([Validators.required])),
    });
  }

  getddressConfig() {
    this.configService.fetchConfig('save_reciever_address').then(res => {
      if (res.data) {
        this.recieverAddressGroup.get('saveAddress').patchValue(res.data[0] == true ? 'Yes' : 'No');
      }
    });
  }
  saveRecieverAddress() {
    let b: boolean = this.recieverAddressGroup.value.saveAddress === 'Yes';
    const configData = {
      config_id: 'save_reciever_address',
      data: [b],
    };
    this.saveConfig(configData);
  }

  saveConfig(config: any) {
    this.configService.saveConfig(config).subscribe(res => {
      this.snackBarService.createSnackBar(
        basicSnackBarConfig.addressComponentSave?.message,
        basicSnackBarConfig.addressComponentSave?.horizontalPosition,
        basicSnackBarConfig.addressComponentSave?.verticalPosition,
        basicSnackBarConfig.addressComponentSave?.duration
      );
      if (res) {
        this.configService.putConfig(config.config_id, res['data']);
      }
    });
  }
}
